import apiClient from '@/api/apiClient';

export default {
  getRoles(): Promise<any[]> {
    return apiClient.get('/account-admin/roles');
  },
  createRole(data: any): Promise<any> {
    return apiClient.post('/account-admin/roles', data);
  },
  updateRole(role_id: string, data: any): Promise<any> {
    return apiClient.patch(`/account-admin/roles/${role_id}`, data);
  },
  deleteRole(role_id: string): Promise<void> {
    return apiClient.delete(`/account-admin/roles/${role_id}`);
  },
};
